
<section
  class="featured-guides-container flex flex-col justify-center px-10 font-rubik"
  aria-labelledby="featured-guides-heading"
>
  <h2 id="featured-guides-heading" class="featured-guides-text">FEATURED GUIDES</h2>

  <nav
    class="flex flex-row justify-end items-center gap-14"
    aria-label="Highlighted educational guides"
  >
    <!-- Buyers Guide -->
    <article
      class="guides-card-container w-full h-full flex flex-row justify-between items-center gap-5"
      role="button"
      tabindex="0"
      @click="goTo('/buyers-guide')"
      aria-label="Buyers Guide"
    >
      <img
        class="guides-card-img"
        src="@/images/header/dropdown-featured-guides-img-01.png"
        alt="Cover of Buyers Guide"
      />

      <div>
        <h3 class="guides-card-h3">Buyers Guide</h3>
        <p class="guides-card-p">
          Tips for buying a shipping container for countless applications.
        </p>
      </div>

      <a
        href="/buyers-guide"
        class="guides-card-btn"
        aria-label="Read Buyers Guide"
      >
        <img
          class="guides-card-btn-img"
          src="@/images/header/arrow_forward.svg"
          alt=""
          aria-hidden="true"
        />
      </a>
    </article>

    <!-- Renters Guide -->
    <article
      class="guides-card-container w-full h-full flex flex-row justify-between items-center gap-5"
      role="button"
      tabindex="0"
      @click="goTo('/renters-guide')"
      aria-label="Renters Guide"
    >
      <img
        class="guides-card-img"
        src="@/images/header/dropdown-featured-guides-img-02.png"
        alt="Cover of Renters Guide"
      />

      <div>
        <h3 class="guides-card-h3">Renters Guide</h3>
        <p class="guides-card-p">
          See why renting may be more beneficial than a purchase – or not.
        </p>
      </div>

      <a
        href="/renters-guide"
        class="guides-card-btn"
        aria-label="Read Renters Guide"
      >
        <img
          class="guides-card-btn-img"
          src="@/images/header/arrow_forward.svg"
          alt=""
          aria-hidden="true"
        />
      </a>
    </article>
  </nav>
</section>
